import { IAppContext } from 'App/AppContext';
import { TFunction } from 'i18next';
import Joi from 'joi';
import TaskTypeFormElement from 'models/tasks/taskTypeFormElement';
import { apiGetTaskTypeName } from 'services/Api/taskService';
import { apiRequest } from 'services/Auth/authConfig';
import { getLocalizedMessageOptions } from 'services/Localization/joiValidation';
import { TaskType_Translation } from './taskType_Translation';

export enum SystemTaskTypes {
  None = 0,
  Approval = 1,
  DPIA = 2,
  ProcessingActivityApproval = 3,
  // RiskAssesment = 2,
  // SupplierAssesment = 3,
  // InternalAudit = 4,
}

export default class TaskType {
  taskTypeId: number;

  authSchemaId?: number;

  systemTaskType?: number;

  isSystem: boolean;

  trans: TaskType_Translation[];

  transIdx: number;

  name: string;

  description?: string;

  tabName?: string;

  form?: TaskTypeFormElement[];

  constructor() {
    this.taskTypeId = 0;
    this.trans = [];
    this.name = '';
    this.transIdx = -1;
    this.isSystem = false;
  }

  static getSystemTypeText(systemTaskType: SystemTaskTypes, t: TFunction<string[]>) {
    switch (systemTaskType) {
      case SystemTaskTypes.Approval:
        return t('forms:SystemTypes.Approval');
      case SystemTaskTypes.DPIA:
        return t('forms:SystemTypes.DPIA');
      case SystemTaskTypes.ProcessingActivityApproval:
        return t('forms:SystemTypes.ProcessingActivityApproval');
      default:
        return '';
    }
  }

  getTransIdx(langCode: string, defLangCode: string): number {
    if (this.trans) {
      //find requested language
      for (let i = 0; i < this.trans.length; i++) {
        const t: TaskType_Translation = this.trans[i];
        if (t.lang?.code === langCode) {
          return i;
        }
      }

      //if not found, find the default language
      for (let i = 0; i < this.trans.length; i++) {
        const t: TaskType_Translation = this.trans[i];
        if (t.lang?.code === defLangCode) {
          return i;
        }
      }
    }

    return -1;
  }

  clone(): TaskType {
    const output = new TaskType();
    output.taskTypeId = this.taskTypeId;
    output.systemTaskType = this.systemTaskType;
    output.isSystem = this.isSystem;
    output.description = this.description;
    output.name = this.name;
    output.transIdx = this.transIdx;
    output.trans = [...this.trans];
    output.authSchemaId = this.authSchemaId;
    output.tabName = this.tabName;

    return output;
  }

  isEqual(item: TaskType): boolean {
    if (item.name !== this.name) return false;
    if (item.description !== this.description) return false;
    if (item.systemTaskType !== this.systemTaskType) return false;
    if (item.taskTypeId !== this.taskTypeId) return false;
    if (item.isSystem !== this.isSystem) return false;
    if (item.authSchemaId !== this.authSchemaId) return false;
    if (item.tabName !== this.tabName) return false;

    return true;
  }

  validate(localizedFields: Record<string, string>): Joi.ValidationResult {
    const schema: Joi.ObjectSchema = Joi.object({
      name: Joi.string().max(512).required().label(localizedFields['name']),
      tabname: Joi.string().max(32).label(localizedFields['tabname']),
    }).prefs(getLocalizedMessageOptions());

    return schema.validate(
      {
        name: this.name,
      },
      { abortEarly: false },
    );
  }

  static async nameExists(orgName: string, appContext: IAppContext): Promise<number> {
    const accessToken = await appContext.getAccessToken(apiRequest.scopes);

    return await apiGetTaskTypeName(orgName, accessToken);
  }
}
